export const RECEIVE_REGISTRY_ITEM = 'zola/item/RECEIVE_REGISTRY_ITEM';
export const REQUEST_REGISTRY_ITEM = 'zola/item/REQUEST_REGISTRY_ITEM';
export const UPDATE_REGISTRY_ITEM = 'zola/item/UPDATE_REGISTRY_ITEM';
export const RECEIVE_PRODUCT_RECOMMENDATIONS = 'zola/nav/RECEIVE_PRODUCT_RECOMMENDATIONS';
export const REGISTRY_ITEM_TOGGLE_CONFIRMATION = 'zola/nav/REGISTRY_ITEM_TOGGLE_CONFIRMATION';
export const REGISTRY_ITEM_UPDATED = 'zola/nav/REGISTRY_ITEM_UPDATED';
export const RESET_ITEM_DRAWER = 'zola/nav/RESET_ITEM_DRAWER';
